import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex items-center gap-5 mt-7 mb-5 flex-wrap" }

import { FiltersType } from '~src/admin/types';
import Badge from '../base/Badge.vue';
import IconClose from '../icons/IconClose.vue';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveFilters',
  props: {
    activeFilters: {}
  },
  emits: ["updateStatus", "updateKeywords"],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Props


// Emits
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.activeFilters.search)
      ? (_openBlock(), _createBlock(Badge, {
          key: 0,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.activeFilters.search), 1),
            _createVNode(IconClose, {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeFilters.search = ''))
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFilters.status, (status, i) => {
      return (_openBlock(), _createBlock(Badge, {
        size: "large",
        key: i
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref($gettext)('Status')) + ": " + _toDisplayString(status), 1),
          _createVNode(IconClose, {
            class: "cursor-pointer",
            onClick: ($event: any) => (emit('updateStatus', status))
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFilters.keywords, (keyword, i) => {
      return (_openBlock(), _createBlock(Badge, {
        size: "large",
        key: i
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref($gettext)('Keyword')) + ": " + _toDisplayString(keyword), 1),
          _createVNode(IconClose, {
            class: "cursor-pointer",
            onClick: ($event: any) => (emit('updateKeywords', keyword))
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})